mutation TranscribeActivityCall($input: ActivityTranscribeCallInput!) {
    activityTranscribeCall(input: $input) {
        activity {
            id
            transcription
            transcriptionStatus
        }
    }
}
